import { render, staticRenderFns } from "./measurement.vue?vue&type=template&id=6bfae440&scoped=true&functional=true"
import script from "./measurement.vue?vue&type=script&lang=js"
export * from "./measurement.vue?vue&type=script&lang=js"
import style0 from "./measurement.vue?vue&type=style&index=0&id=6bfae440&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "6bfae440",
  null
  
)

export default component.exports